import * as THREE from 'three';

let initialLightDefaults = {
  castShadow: true,
  color: { r: 1, g: 1, b: 1 },
  intensity: 0.85,
  lightType: 'DirectionalLight',
  radius: 0,
  shadowBias: 0,
  shadowCameraSize: 1.7321,
  shadowDarkness: 0.1,
  shadowFarClip: 40,
  shadowFrustumColor: { r: 1, g: 1, b: 1 },
  shadowNearClip: 10,
  shadowSize: 1024,
  showShadowCamera: false,
};

export function createLight(data, light) {
  const type = data.lightType;
  // Skip AreaLight without crashing for now
  if (type === 'AreaLight') return;
  if (!THREE[type]) throw new Error('Unknown light type: ' + type);
  if (type === 'HemisphereLight') {
    return new THREE[type](data.color.getHex(), data.gndColor.getHex(), data.intensity);
  }

  return new THREE[type](data.color.getHex(), data.intensity);
}

export function updateLight(data, light) {
  light.intensity = data.intensity;
}



// WEBPACK FOOTER //
// ./src/translators/light.js